import { defaultFirmaHistorikstamdata2Columns } from "../../config/firmaConfig";
import {
  Adresse,
  FirmaAbonnement,
  FirmaBetalingsadresse,
  FirmaDto,
  Firmahistorik,
  FirmaKlienterklaering,
  FirmaKorrespondance,
  FirmaSanktion,
  FirmaTilsyn,
  Firmaejerskab,
  PersonFirma,
  Firmahistorik2,
} from "../../interfaces/schema";
import { getFields } from "../../util/graphqlUtil";
import { Field } from "../../util/typeUtil";

export const firmaAutoCompleteFields = getFields<Field<FirmaDto, 0>>([
  "id",
  "navn1",
  "navn2",
  "firmaNr",
  "kommuneNr",
  "aktiv",
  "firmatype",
  "cvrNr",
]);

export const firmaPersonFirma = getFields<Field<PersonFirma, 3>>([
  "id",
  "emailArbejde",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "person.id",
  "person.fuldtNavn",
  "person.kundeNr",
  "person.personPersonart.personartNr",
  "person.personPersonart.periode.fraDato",
  "person.personPersonart.periode.tilDatoInklusiv",
  "person.personPersonart.personartNr",
]);

export const firmaTilsynFields = getFields<Field<FirmaTilsyn, 1>>([
  "id",
  "gennemfoerselDato",
  "firmaTilsynstype",
  "firmaTilsynstypeNavigation.navn",
  "sagsNr",
  "bemaerkning",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
]);

export const firmaSanktionFields = getFields<Field<FirmaSanktion, 1>>([
  "id",
  "afgoerelseskoder",
  "bemaerkninger",
  "sagsNr",
  "sagsLink",
  "naevnskendelseDato",
  "naevnskendelseBoedebeloeb",
  "indbragtretten",
  "retskendelseDato",
  "retskendelseBoedebeloeb",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "naevnskendelseSanktionstypeNrNavigation.nr",
  "naevnskendelseSanktionstypeNrNavigation.navn",
]);

export const firmaKorrespondanceFields = getFields<
  Field<FirmaKorrespondance, 0>
>([
  "id",
  "beskrivelse",
  "dokument",
  "dokumentNr",
  "filnavn",
  "navn",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
]);

export const firmaKlientErklaeringFields = getFields<
  Field<FirmaKlienterklaering, 1>
>([
  "id",
  "erklAar",
  "erklDocument",
  "erklModtaget",
  "erklNr",
  "erklNrWeb",
  "firmaCvrNr",
  "koerselDato",
  "frist",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "klienterklaeringStatusNavigation.navn",
  "klienterklaeringStatusNavigation.nr",
  "klienterklaeringstypeNavigation.navn",
  "klienterklaeringstypeNavigation.nr",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
]);

export const firmaejerskabFields = getFields<Field<Firmaejerskab, 2>>([
  "id",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "ejetFirma.id",
  "ejetFirma.cvrNr",
  "ejetFirma.firmaNr",
  "ejetFirma.navn1",
  "ejetFirma.pnr",
  "ejetFirma.periode.fraDato",
  "ejetFirma.periode.tilDatoInklusiv",
  "ejendeFirmaNavigation.id",
  "ejendeFirmaNavigation.cvrNr",
  "ejendeFirmaNavigation.firmaNr",
  "ejendeFirmaNavigation.navn1",
  "ejendeFirmaNavigation.pnr",
  "ejendeFirmaNavigation.periode.fraDato",
  "ejendeFirmaNavigation.periode.tilDatoInklusiv",
]);

export const firmaAbonnementFields = getFields<Field<FirmaAbonnement, 1>>([
  "id",
  "antalEksemplar",
  "faktureres",
  "sidsteOpkraevningsaar",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "abonnementNrNavigation.nr",
  "abonnementNrNavigation.navn",
]);

export const firmaBeliggenhedsadresseFields = getFields<Field<Adresse, 1>>(
  [
    "adresselinie1",
    "adresselinie2",
    "adresselinie4",
    "bynavn",
    "postnummer",
    "landekode",
    "coNavn",
    "toLines",
    "darAdresseId",
    "landNavigation.navn",
  ],
  true,
);

export const firmaBetalingsadresseFields = getFields<
  Field<FirmaBetalingsadresse, 2>
>([
  "id",
  "email",
  "bemaerkning",
  "opretDato",
  "opretInit",
  "retteInit",
  "retteDato",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "adresse.adresselinie1",
  "adresse.adresselinie2",
  "adresse.adresselinie4",
  "adresse.postnummer",
  "adresse.bynavn",
  "adresse.landekode",
  "adresse.toLines",
  "adresse.darAdresseId",
  "adresse.coNavn",
  "adresse.landNavigation.navn",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "reference",
]);

export const firmaHistorikFields = getFields<Field<Firmahistorik, 0>>([
  "id",
  "adr1",
  "adr2",
  "adr3",
  "adr4",
  "aktiv",
  "emailArbejde",
  "emailSikkerArbejde",
  "kommuneNavn",
  "kredsNavn",
  "land",
  "postboks",
  "regionNavn",
  "adrCo",
  "cvrNr",
  "etageNr",
  "firmatype",
  "firmaStartDato",
  "husNr",
  "husNrBogstav",
  "navn1",
  "navn2",
  "navn3",
  "pnr",
  "postNr",
  "retskreds",
  "side",
  "tlf",
  "webAdresse",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
]);

export const firmaHistorik2Fields = getFields<Field<Firmahistorik2, 0>>(
  defaultFirmaHistorikstamdata2Columns.map((item) => item.field),
);

export const firmaDtoFields = getFields<Field<FirmaDto, 2>>([
  "id",
  "bemaerkninger",
  "cvrNr",
  "cvrNrStatusCvr",
  "udenlandskVirksomhedsId",
  "ean",
  "email",
  "emailSikker",
  "fakturaAfsendelse",
  "fakturaEmail",
  "firmaNr",
  "advokatVirksomhed",
  "kommuneNr",
  "retskredsNr",
  "navn1",
  "navn2",
  "pnr",
  "pnrStatusCvr",
  "pnrOphoertCvr",
  "selskabstype",
  "virksomhedsform",
  "tlf",
  "webAdresse",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "retskredsNrNavigation.nr",
  "retskredsNrNavigation.navn",
  "retskredsNrNavigation.advokatkredsNrNavigation.navn",
  "kommuneNavigation.navn",
  "kommuneNavigation.regionNrNavigation.navn",
  "fakturaReference",
  "fakturaAfsendNavigation.navn",
  "fakturaAfsendNavigation.nr",
  "aktiv",
]);
